import './MswLoader.scss';
import {Component} from 'react';

export class MswLoader extends Component {
    render() {
        return <div className="loader">
            <div className="wave"></div>
        </div>;
    }
}